import React, { FC, useCallback, useState, ChangeEvent } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Modal,
  Stack,
  TextField,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface IProps {
  isOpen: boolean;
  setIsOpen(val: boolean): void;
  onProductAdd(name: string, price: number): void;
}

const AddCategoryModal: FC<IProps> = ({ isOpen, setIsOpen, onProductAdd }) => {
  const [name, setName] = useState<string>('');
  const [price, setPrice] = useState<number>(0);

  const handleModalClose = useCallback(() => {
    setName('');
    setPrice(0);
    setIsOpen(false);
  }, []);

  const handleProductAdd = useCallback(() => {
    onProductAdd(name, price);
    setName('');
    setPrice(0);
    setIsOpen(false);
  }, [name, price, onProductAdd]);

  const onNameChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setName(event.currentTarget.value);
    },
    []
  );

  const onPriceChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setPrice(parseInt(event.currentTarget.value || '0', 10));
    },
    []
  );

  return (
    <Modal open={isOpen} onClose={handleModalClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          color: 'text.primary',
          p: 1
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={handleModalClose}>
            <CloseIcon
              sx={(theme) => ({
                '&:hover': {
                  color: theme.palette.error.main
                }
              })}
            />
          </IconButton>
        </Box>
        <Box sx={{ p: 3, pt: 0 }}>
          <Typography variant="h6">Добавление товара</Typography>
          <TextField
            fullWidth
            multiline
            error={!name}
            value={name}
            onChange={onNameChange}
            label="Название"
            placeholder="Ковролин"
            helperText={!name && 'Введите название товара'}
            variant="filled"
            sx={{ mt: '15px' }}
          />
          <TextField
            fullWidth
            error={!price}
            value={price}
            onChange={onPriceChange}
            label="Цена"
            placeholder="0"
            helperText={(!price || price < 0) && 'Цена должна быть больше 0'}
            variant="filled"
            sx={{ mt: '15px' }}
          />
          <Stack
            flexDirection="row"
            gap={2}
            sx={{ pt: 5, justifyContent: 'flex-end' }}
          >
            <Button
              size="small"
              variant="outlined"
              color="success"
              disabled={!name}
              onClick={handleProductAdd}
            >
              Добавить
            </Button>
            <Button size="small" variant="outlined" onClick={handleModalClose}>
              Отменить
            </Button>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddCategoryModal;
